import React from 'react';
import { CountdownTimer } from './CountdownTimer';
import { ShieldCheckIcon } from 'lucide-react';
const CHECKOUT_URL = 'https://checkout.tiendadigitalonline.com/cart/47950473298161:1';
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/dsEDKAqYc1rDnHqLsywCLW/imagen_mocap_del_producto_final_sin_fondo.png';
export function HeroSection() {
  return <section className="w-full bg-white" data-id="element-204">
      {/* Urgency Bar */}
      <div className="w-full bg-black py-3 px-4" data-id="element-205">
        <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-center" data-id="element-206">
          <span className="text-white font-body text-sm md:text-base flex items-center gap-2" data-id="element-207">
            ⏳ OFERTA EXPIRA EN: <CountdownTimer data-id="element-208" />
          </span>
          <span className="text-white font-body text-sm md:text-base" data-id="element-209">|</span>
          <span className="text-urgency-500 font-heading font-bold text-sm md:text-base tracking-wide" data-id="element-210">
            🔥 CUPOS LIMITADOS
          </span>
        </div>
      </div>

      {/* Hero Content */}
      <div className="max-w-3xl mx-auto px-4 py-12 md:py-16 text-center" data-id="element-211">
        <p className="text-gold-600 font-body text-base md:text-lg mb-6" data-id="element-212">
          🔮 Para personas que quieren entender el Tarot y conocerse
          profundamente, sin experiencia previa
        </p>

        <h1 className="font-heading font-bold text-3xl md:text-5xl lg:text-6xl text-gray-900 leading-tight mb-6" data-id="element-213">
          ✨ E-book Tarot y Autoconocimiento: curso completo desde cero
        </h1>

        {/* Product Image */}
        <a href={CHECKOUT_URL} className="inline-block my-8 cursor-pointer" aria-label="Acceder al curso" data-id="element-214">
          <img src={PRODUCT_IMAGE} alt="E-book Tarot y Autoconocimiento - Curso completo desde cero" className="w-full max-w-lg mx-auto drop-shadow-2xl hover:scale-105 transition-transform duration-300" data-id="element-215" />
        </a>

        <p className="font-body text-lg md:text-xl text-gray-700 leading-relaxed mb-4 max-w-2xl mx-auto" data-id="element-216">
          Aprendé a leer el Tarot como herramienta de transformación personal,
          con una guía clara, práctica y paso a paso.
        </p>

        <p className="font-body text-lg md:text-xl text-gray-900 font-semibold mb-10" data-id="element-217">
          Sin conocimientos previos. Sin confusión. Sin vueltas.
        </p>

        {/* CTA Button */}
        <a href={CHECKOUT_URL} className="inline-block bg-gradient-to-r from-gold-500 to-gold-600 text-black font-heading font-bold text-xl md:text-2xl px-10 py-5 rounded-lg animate-pulse-glow hover:from-gold-400 hover:to-gold-500 transition-all duration-300 uppercase tracking-wide" data-id="element-218">
          👉 SÍ, QUIERO ACCEDER AHORA
        </a>

        <div className="mt-6 flex items-center justify-center gap-2 text-gray-600 font-body text-sm" data-id="element-219">
          <ShieldCheckIcon className="w-5 h-5 text-green-600" data-id="element-220" />
          <span data-id="element-221">✅ Garantía de satisfacción de 7 días</span>
        </div>
      </div>
    </section>;
}